import { Badge } from "@/client/components/shad/badge";
import { Button } from "@/client/components/shad/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/shad/card";
import { useAuth } from "@/client/hooks/useAuth";
import { IconArrowBack } from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";
import { UserRoleBadge } from "./UserRoleBadge";
import type { PropsWithChildren } from "react";

export const UserCard = ({ children }: PropsWithChildren) => {
  const { user } = useAuth();

  const isAdmin = user.role === "ADMIN";

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex gap-2 items-center">
          {user.firstName} {user.lastName}
          <UserRoleBadge role={user.role} />
        </CardTitle>
        <CardDescription>
          <dl className="flex gap-2">
            <dt>Email:</dt>
            <dd>{user.email}</dd>
          </dl>
          <dl className="flex gap-2">
            <dt>Phone:</dt>
            <dd>{user.contact1}</dd>
          </dl>
        </CardDescription>
      </CardHeader>
      {isAdmin && <CardContent>{children}</CardContent>}
    </Card>
  );
};
